import { UserDateFormat, UserFormat } from '@agilox/ui-common';

export function mapUserFormat(userFormat: UserFormat): UserFormat {
	return {
		date: yearToLowerCase(userFormat.date) as UserDateFormat,
		time: userFormat.time,
		number: userFormat.number,
	};
}

function yearToLowerCase(format: UserDateFormat): UserDateFormat {
	return format.replace(/YY/g, 'yy') as UserDateFormat;
}
